module.exports = __webpack_public_path__ + "img/biz.7d2350ce.png";